import { render, staticRenderFns } from "./supplied.vue?vue&type=template&id=c0bc0d46"
import script from "./supplied.vue?vue&type=script&lang=js"
export * from "./supplied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports